import { borderColors } from "../borders";
import { blue, gray } from "../colors";

export const MuiCheckbox = {
  styleOverrides: {
    root: {
      color: borderColors.primary,
      width: 18,
      height: 18,

      "&.MuiCheckbox-indeterminate": {
        color: blue[100],
      },

      "&.Mui-checked": {
        color: blue[100],

        "&.Mui-disabled": {
          color: gray[40],
        },
      },
    },
    "&.Mui-checked": {
      color: blue[100],

      "&.Mui-disabled": {
        color: gray[40],
      },
    },
  },
};
